import { lazy } from 'react';
import { Loadable } from './Loadable';
import { PATH_DASHBOARD } from './paths';

const smsRoutes = [
  {
    component: Loadable(lazy(() => import('../pages/sms/EnvioIndividual'))),
    path: PATH_DASHBOARD.sms.envio_individual.path,
    shouldRender: PATH_DASHBOARD.sms.envio_individual.renderCondition,
  },
  {
    component: Loadable(lazy(() => import('../pages/sms/EnvioMasivo'))),
    path: PATH_DASHBOARD.sms.envio_masivo.path,
    shouldRender: PATH_DASHBOARD.sms.envio_masivo.renderCondition,
  },
  {
    component: Loadable(
      lazy(() => import('../pages/sms/reportes/EstadoDeEnvios')),
    ),
    path: PATH_DASHBOARD.sms.reportes.estado_de_envios.path,
    shouldRender: PATH_DASHBOARD.sms.reportes.estado_de_envios.renderCondition,
  },
  {
    component: Loadable(
      lazy(() => import('../pages/sms/reportes/ResumenDeEnviados')),
    ),
    path: PATH_DASHBOARD.sms.reportes.resumen_de_enviados.path,
    shouldRender:
      PATH_DASHBOARD.sms.reportes.resumen_de_enviados.renderCondition,
  },
  {
    component: Loadable(
      lazy(() => import('../pages/sms/reportes/ResumenPorDia')),
    ),
    path: PATH_DASHBOARD.sms.reportes.resumen_por_dia.path,
    shouldRender: PATH_DASHBOARD.sms.reportes.resumen_por_dia.renderCondition,
  },
  {
    component: Loadable(
      lazy(() => import('../pages/sms/reportes/SmsEnviados')),
    ),
    path: PATH_DASHBOARD.sms.reportes.sms_enviados.path,
    shouldRender: PATH_DASHBOARD.sms.reportes.sms_enviados.renderCondition,
  },
  {
    component: Loadable(
      lazy(() => import('../pages/sms/reportes/SmsRecibidos')),
    ),
    path: PATH_DASHBOARD.sms.reportes.sms_recibidos.path,
    shouldRender: PATH_DASHBOARD.sms.reportes.sms_recibidos.renderCondition,
  },
];

export default smsRoutes;
